import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import type { FormValues } from '~/entities/russia/Organizations/CarRental'
import { AxiosErrorType, CarRental } from '~/shared/api'
import { backFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

export const domain = createDomain('features.organization.carRental.add')
export const Gate = createGate<{ id: UniqueId }>()

export const createFx = domain.createEffect<
  FormValues,
  CarRental,
  AxiosErrorType
>({
  async handler(values) {
    const { ...formData } = values
    const carRental = new CarRental(formData)

    const result = await carRental.save()
    return result.getModel() as CarRental
  },
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.landlord created' as const,
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, backFx],
})
sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})
